import React from 'react';
import styles from './spinner.module.scss';

const Spinner: React.FC<{ text?: string; className?: string }> = ({ text, className }) => {
  return (
    <div data-testid="spinner-component" role="status" className={`${styles.preloaderWrapper} ${className}`}>
      <svg className={styles.spinner} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 186.15 186.05">
        <g>
          <path
            d="M51.68,117.18c-4.2-7.1-6.54-15.42-6.54-24.2,0-26.35,21.68-47.93,47.93-47.93,8.88,0,17.1,2.43,24.2,6.54,1.78,1.03,4.11.75,5.61-.75l25.7-25.7c2.06-2.06,1.78-5.42-.56-7.1C132.32,6.46,112.79-.27,91.77,0,41.59.66.66,41.59,0,91.77c-.28,21.02,6.45,40.55,18.03,56.25,1.68,2.34,5.05,2.52,7.1.56l25.7-25.7c1.59-1.5,1.87-3.83.84-5.7Z"
            fill="currentColor"
          />
          <path
            d="M161,37.48l-25.7,25.7c-1.49,1.5-1.78,3.83-.75,5.61,4.2,7.1,6.54,15.42,6.54,24.2,0,26.35-21.68,47.93-47.93,47.93-8.88,0-17.1-2.43-24.2-6.54-1.78-1.03-4.11-.75-5.61.75l-25.79,25.79c-2.06,2.06-1.78,5.42.56,7.1,15.7,11.59,35.23,18.31,56.25,18.03,50.18-.65,91.1-41.58,91.76-91.76.28-21.02-6.45-40.55-18.03-56.25-1.78-2.34-5.14-2.62-7.1-.56Z"
            fill="currentColor"
          />
        </g>
      </svg>
      <span className="mt-3">{text}</span>
    </div>
  );
};

export default Spinner;
